import { setToken } from '@/utils/auth'
import { commonRequest } from '@/utils/request'

const actions = {
  captcha: () => commonRequest({ method: 'get', url: '/auth/captcha' }),
  verify: ({ commit }, data) => commonRequest({ method: 'post', url: '/auth/verify', data }),
  signup: ({ commit, state }, data) => commonRequest({ url: '/user/signup', data }),
  check_code: ({ commit, state }, data) => commonRequest({ url: '/auth/check_code', data })
}

export default {
  namespaced: true,
  actions
}
